import { compose } from "redux";
import { Field } from "redux-form/immutable";
import React, { PureComponent } from "react";
import { Grid } from "@material-ui/core";
import { withStyles } from "@material-ui/core/styles";

import { BasePageTitle } from "altus-ui-components";

import TextField from "app/components/form/TextField";
import { UPDATE_EMPLOYEE_FORM } from "features/planner/employee/employee.constants";
import { bookingSystemTypeToString } from "features/planner/planner.mappers";
import { BOOKING_SYSTEM_TYPES } from "features/planner/planner.constants";

class DepartureForm extends PureComponent {
  render() {
    const { classes } = this.props;

    return (
      <Grid
        item
        xs={6}
        lg={2}
        container
        direction="column"
        className={classes.root}
      >
        <Grid item>
          <BasePageTitle title="Departure" />
        </Grid>
        <Grid item>
          <Field
            component={TextField}
            name={UPDATE_EMPLOYEE_FORM.TRAVEL_DA_WINCI}
            label={bookingSystemTypeToString(BOOKING_SYSTEM_TYPES.DA_WINCHI)}
          />
        </Grid>
        <Grid item>
          <Field
            component={TextField}
            name={UPDATE_EMPLOYEE_FORM.TRAVEL_VANTAGE}
            label={bookingSystemTypeToString(BOOKING_SYSTEM_TYPES.VANTAGE)}
          />
        </Grid>
        <Grid item>
          <Field
            component={TextField}
            name={UPDATE_EMPLOYEE_FORM.TRAVEL_TICKET}
            label={bookingSystemTypeToString(BOOKING_SYSTEM_TYPES.TICKET)}
          />
        </Grid>
        <Grid item>
          <Field
            label="Airport"
            component={TextField}
            name={UPDATE_EMPLOYEE_FORM.TRAVEL_AIRPORT}
          />
        </Grid>
      </Grid>
    );
  }
}

const styles = () => ({
  root: {},
});

export default compose(withStyles(styles))(DepartureForm);
